var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFifth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#21AAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3899 26.7305H33.6607V36.0876C34.4268 35.1391 35.5212 34.373 36.9439 33.7893C38.3666 33.1692 39.8805 32.8591 41.4856 32.8591C44.404 32.8591 46.7934 33.4975 48.6539 34.7743C50.5144 36.0511 51.8641 37.6927 52.7031 39.699C53.5422 41.6689 53.9617 43.7848 53.9617 46.0465C53.9617 50.2417 52.7579 53.616 50.3502 56.1696C47.979 58.7232 44.5864 60 40.1724 60C36.0137 60 32.694 58.9603 30.2134 56.881C27.7328 54.8016 26.3283 52.0839 26 48.7278H33.4419C33.7702 50.187 34.4998 51.3543 35.6306 52.2298C36.798 53.1053 38.2754 53.5431 40.0629 53.5431C42.2152 53.5431 43.8386 52.8682 44.933 51.5185C46.0274 50.1687 46.5746 48.3812 46.5746 46.1559C46.5746 43.8942 46.0091 42.1797 44.8783 41.0123C43.7839 39.8085 42.1605 39.2066 40.0082 39.2066C38.4761 39.2066 37.1993 39.5896 36.1778 40.3557C35.1564 41.1217 34.4268 42.1432 33.9891 43.42H26.6566V20H51.3899V26.7305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifth);
export default __webpack_public_path__ + "static/media/fifth.6321a459d087ae9d453420a617fb428a.svg";
export { ForwardRef as ReactComponent };